/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type FormatDate = {
    format: FormatDate.format;
    dateFormat: string;
};
export namespace FormatDate {
    export enum format {
        DATE = 'date',
    }
}

